<script lang="ts" setup>
import useAcfOptions from '../../composables/use-acf-options';
const socialMediaLinks: any = await useAcfOptions('social_media_links');
</script>

<template>
  <div class="container-fluid bg-dark footer-icon-div">
      <div class="container-xl">
        <div class="row py-4">
          <div class="logo col-12 col-lg-6 d-flex flex-row align-items-center justify-content-md-start justify-content-center">
            <a href="/" aria-label="Marella Homes">
              <NuxtImg class="footer-icon-logo" loading="lazy" src="/marella-footer-logo.svg" alt="Marella Homes" 
              sizes="sm:200px, md:300px"/>
            </a>
          </div>
          <div class="icons col-12 col-lg-6 d-flex flex-row align-items-center justify-content-md-end justify-content-center">
            <template v-for="link in socialMediaLinks">
              <a v-if="link?.show_in_footer" :href="link?.url" class="ms-md-4 ms-0" target="_blank" :aria-label="link?.name">
                <span class="d-flex align-items-center justify-content-center rounded-circle bg-secondary icon-circle">
                  <Icon size="30px" :name="link?.icon_name"/>
                </span>
              </a>
            </template>
          </div>
        </div>
      </div>
  </div>
</template>